<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Reports" title="Call Log Report" />

		<div class="container-fluid">
			<div class="card">
				<div class="card-body">
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-2">
								<label class="control-label">From Date:<span class="text-danger">*</span></label>
								<input class="form-control" type="date" v-model="start_date" :max="max" value-as-string>
							</div>
							<div class="col-md-2">
								<label class="control-label">To Date:<span class="text-danger">*</span></label>
								<input class="form-control" type="date" v-model="end_date" :max="max" value-as-string>
							</div>
							<div class="col-md-2">
								<label class="control-label">Staff</label>
								<select class="form-select" v-model="staff_id">
									<option value="">All Staffs</option>
									<option v-for="staff in staffs" :key="staff.id" :value="staff.id">{{ staff.name }}</option>
								</select>
							</div>
							<div class="col-md-2 d-flex align-items-end">
								<button type="button" class="btn btn-primary me-2" @click="viewReport(1)" :disabled="!dates_selected || loading">
									{{ loading ? 'Loading...' : 'View' }}
								</button>
								<button type="button" class="btn btn-success" @click="downloadExcel()" :disabled="!dates_selected || excel_loading">
									{{ excel_loading ? 'Exporting...' : 'Excel' }}
								</button>
							</div>
							<div class="col-md-4 d-flex align-items-end justify-content-end">
								<div class="text-end">
									<label class="control-label d-block">Total Calls:</label>
									<span class="badge rounded-pill bg-primary fs-6">{{ total }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card">
				<div class="card-body">
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-6 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="viewReport(1)">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="100">100</option>
									</select>
									<span>entries</span>
								</label>
							</div>
						</div>
					</div>

					<div class="table-responsive product-table">
						<table class="display" id="basic-1">
							<thead>
								<tr align="center">
									<th>#</th>
									<th>IMEI</th>
									<th>Call Type</th>
									<th>Staff</th>
									<th>Status</th>
									<th>Remarks</th>
									<th>Log Date</th>
								</tr>
							</thead>
							<tbody v-if="call_logs.length">
								<tr v-for="(log, index) in call_logs" :key="log.id" align="center">
									<td>{{ (from || 1) + index }}</td>
									<td>{{ log.imei }}</td>
									<td>
										<span v-if="log.type == 6" class="badge rounded-pill bg-primary">Customer Info</span>
										<span v-else class="badge rounded-pill bg-info">Dealer Info</span>
									</td>
									<td>{{ log.staff_name || '-' }}</td>
									<td>
										<span v-if="log.status == 0" class="badge rounded-pill bg-warning">Pending</span>
										<span v-else-if="log.status == 1" class="badge rounded-pill bg-primary">Attended</span>
										<span v-else-if="log.status == 2" class="badge rounded-pill bg-success">Completed</span>
										<span v-else class="badge rounded-pill bg-secondary">-</span>
									</td>
									<td>{{ log.remarks || '-' }}</td>
									<td>{{ log.log_date ? $filters.formatDateTime(log.log_date) : '-' }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="7" align="center">{{ viewed ? 'No data available in the table' : 'Select dates and click View' }}</td>
								</tr>
							</tbody>
						</table>
					</div>

					<caption v-if="call_logs.length" class="float-start mt-2 d-block d-lg-inline">Showing {{ from }} to {{ to }} of {{ total }} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end" v-if="last_page > 1">
						<ul class="pagination">
							<li class="page-item" :class="{ disabled: current_page <= 1 }">
								<a class="page-link" href="#" @click.prevent="viewReport(current_page - 1)" tabindex="-1">Prev</a>
							</li>
							<li class="page-item disabled">
								<span class="page-link">Page {{ current_page }} of {{ last_page }}</span>
							</li>
							<li class="page-item" :class="{ disabled: current_page >= last_page }">
								<a class="page-link" href="#" @click.prevent="viewReport(current_page + 1)">Next</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Call Log Report",

	data() {
		const today = new Date().toISOString().slice(0, 10);
		return {
			start_date: '',
			end_date: today,
			max: today,
			staff_id: "",
			staffs: [],
			listing_length: 20,
			token: "",
			call_logs: [],
			total: 0,
			from: 0,
			to: 0,
			current_page: 1,
			last_page: 1,
			loading: false,
			excel_loading: false,
			viewed: false,
		};
	},

	computed: {
		dates_selected() {
			return !!(this.start_date && this.end_date);
		},
	},

	created() {
		this.fetchStaffs();
	},

	methods: {
		getToken() {
			if (localStorage.getItem('airotrack_staff')) {
				const airotrack_staff = JSON.parse(localStorage.getItem('airotrack_staff'));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		fetchStaffs() {
			this.getToken();
			this.$axios
				.get("/staffs/staffsList", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					this.staffs = res.data.data;
				})
				.catch((err) => console.log(err));
		},

		buildParams(page = 1) {
			return new URLSearchParams({
				limit: this.listing_length,
				page: page,
				from_date: this.start_date,
				to_date: this.end_date,
				staff_id: this.staff_id || "",
			});
		},

		viewReport(page = 1) {
			if (!this.dates_selected || page < 1 || (this.viewed && page > this.last_page)) return;

			this.getToken();
			this.loading = true;
			this.$axios
				.get("/staffs/callLogReport?" + this.buildParams(page).toString(), { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data.call_logs;
					this.call_logs = data.data;
					this.current_page = data.current_page;
					this.last_page = data.last_page;
					this.total = data.total;
					this.from = data.from || 0;
					this.to = data.to || 0;
					this.viewed = true;
				})
				.catch((err) => console.log(err))
				.finally(() => {
					this.loading = false;
				});
		},

		downloadExcel() {
			if (!this.dates_selected) return;

			this.getToken();
			this.excel_loading = true;
			this.$axios
				.get("/staffs/callLogReportExcel?" + this.buildParams().toString(), { headers: { Authorization: "Bearer " + this.token }, responseType: "blob" })
				.then((response) => {
					const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = "call_log_report_" + this.start_date + "_" + this.end_date + ".xlsx";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(link.href);
				})
				.catch((err) => console.log(err))
				.finally(() => {
					this.excel_loading = false;
				});
		},
	},
};
</script>
